// store/modules/navigation.js
const state = {
    selectedNav: null, // 当前选中的导航项
    navHistory: [] // 导航历史记录
};

const mutations = {
    SET_SELECTED_NAV(state, navItem) {
        state.selectedNav = navItem;
    },

    ADD_NAV_HISTORY(state, navItem) {
        // 避免重复添加
        const exists = state.navHistory.find(item => item.id === navItem.id);
        if (!exists) {
            state.navHistory.push(navItem);
            // 限制历史记录数量
            if (state.navHistory.length > 50) {
                state.navHistory.shift();
            }
        }
    },

    CLEAR_NAV_HISTORY(state) {
        state.navHistory = [];
    }
};

const actions = {
    selectNav({ commit }, navItem) {
        commit('SET_SELECTED_NAV', navItem);
        commit('ADD_NAV_HISTORY', navItem);
    },

    clearNavHistory({ commit }) {
        commit('CLEAR_NAV_HISTORY');
    }
};

const getters = {
    selectedNav: state => state.selectedNav,
    navHistory: state => state.navHistory
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
